var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 30.624,
    r: 29.624,
    fill: "white",
    stroke: "#CDCEDE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.0001,
    cy: 30.6242,
    r: 26.3586,
    fill: "#CBCAED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_16091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6841 35.3369L25.5389 38.4432L26.9073 32.5864L22.3641 28.6453L28.3578 28.1253L30.6841 22.6106L33.0241 28.139L39.0178 28.659L34.4747 32.6001L35.8431 38.4569L30.6841 35.3369Z",
    fill: "#F0FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3684 26.9074L34.5295 26.0589L30.6842 17L26.8389 26.0726L17 26.9074L24.4716 33.38L22.2274 43L30.6842 37.8958L39.1411 43L36.9105 33.38L44.3684 26.9074ZM30.6842 35.3368L25.5389 38.4432L26.9074 32.5863L22.3642 28.6453L28.3579 28.1253L30.6842 22.6105L33.0242 28.1389L39.0179 28.6589L34.4747 32.6L35.8432 38.4568L30.6842 35.3368Z",
    fill: "#F0FAF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_16091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(7 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.221474bf9514990de14a498b4ae2505a.svg";
export { ForwardRef as ReactComponent };